import { RootStateOrAny } from 'react-redux';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { getOrderTypes } from "../../../connectors/orderTypes/connectors";
import { translateOrderTypeItemName } from "../../common/enums/orderTypes.enum";
import {
  Selection,
} from "office-ui-fabric-react/lib/DetailsList";

export const useDetailGroupedList = (onSelection?: any, onInvoke?: any) => {
  const { t } = useTranslation("admin");
  const { data, status } = useQuery("orderTypes", getOrderTypes);
  const [groups, setGroups] = useState<any>(undefined);
  const [items, setItems] = useState<any>([]);
  const {selectedOrderTypes} = useSelector((state: RootStateOrAny) => state.orderTypes)
  const fetchedData = useMemo(() => {
    if(data){
      return data.data.data
    }else return ""
  },[data])
 
  useEffect(() => {
    if (data) {
      generateGroups(data.data.data);
      generateItems(data.data.data);
    }
  }, [JSON.stringify(fetchedData), t]);

  const typeNameMap: any = {
    "Pojazd": t("orders.typeValues.vehicle"),
    "Tonaż": t("orders.typeValues.tonnage"),
    "Kontener": t("orders.typeValues.container"),
  };

  const generateGroups = (items: Array<any>) => {
    let index = 0;
    const gr = items.map((item: any) => {
      const displayName = typeNameMap[item.name] !== undefined ? typeNameMap[item.name] : item.name;
      const grItem = {
        name: t("orderTypes.groupPrefix") + ": " + displayName,
        count: item.items.length,
        key: item.name,
        startIndex: index,
      };
      index += item.items.length;
      return grItem;
    });

    setGroups(gr);
  };
  const columns = useMemo(
    () => [
      {
        key: "thumbnail",
        minWidth: 16,
        maxWidth: 16,
        fieldName: "thumbnail",
        name: "thumbnail",
        isIconOnly: true,
        isResizable: false,
      },
      {
        key: "name",
        name: t("orderTypes.colName"),
        fieldName: "name",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        // display only - item.name stays untranslated for editing
        onRender: (item: any) => translateOrderTypeItemName(item.name, t),
      },
      {
        key: "value",
        name: t("orderTypes.colCapacity"),
        fieldName: "value",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
      },
    ],
    [t]
  );

  const generateItems = (items: Array<any>) => {
    const arr: Array<any> = [];
    items.forEach((item: any) => {
      const parsedItems = item.items.map((item: any) => {
        const convertedString = item.value.toString().replace(/[,.]/g, (m: any) => (m === ',' ? '.' : ','))
        return{
          ...item,
          value: convertedString
        }
      })
      
      arr.push(...parsedItems);
    });
    setItems(arr);
  };

  const selection = useMemo(
    () =>
      new Selection({
        onSelectionChanged: () => {
            if(onSelection){
              onSelection(selection.getSelection())
            }
        },
      }),
    []
  );

  const handleInvoke = (item: any) => {
    if(onInvoke){
      onInvoke()
    }
  };

  return {
    groups,
    items,
    columns,
    selection,
    handleInvoke,
    selectedOrderTypes,
   status
  };
};